<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- detail_Basic Info -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>{{ $t('FIELD.GLOBAL.SUBJECT') }}<em class="txt_mandatory">*</em></th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input" v-clearable v-model="subject" />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.GLOBAL.CATEGORY') }}<em class="txt_mandatory">*</em></th>
                        <td>
                            <fieldset class="ui_fieldset set_3">
                                <div>
                                    <select class="slt_white w100p" v-model="category1Code" @change="categoryList(2)">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in category1CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p" v-model="category2Code" @change="categoryList(3)">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in category2CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p" v-model="category3Code">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in category3CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </div>
                            </fieldset>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.MYKNOWLEDGE.KEYWORD') }}<em class="txt_mandatory">*</em></th>
                        <td>
                            <fieldset class="ui_fieldset set_3">
                                <div>
                                    <span class="clearable">
                                        <input type="text" class="text_input" v-clearable v-model="keyword1" />
                                    </span>
                                </div>
                                <div>
                                    <span class="clearable">
                                        <input type="text" class="text_input" v-clearable v-model="keyword2" />
                                    </span>
                                </div>
                                <div>
                                    <span class="clearable">
                                        <input type="text" class="text_input" v-clearable v-model="keyword3" />
                                    </span>
                                </div>
                            </fieldset>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t('FIELD.GLOBAL.ETC.002') }}
                            <em class="txt_mandatory">*</em>
                            <em class="ico_info">
                                <i class="tooltip fl_btm">
                                    Uploaded images are available to all subsidiaries. Please do not upload images that
                                    are specific to certain subsidiaries or individuals.
                                </i>
                            </em>
                        </th>
                        <td>
                            <!-- <div class="attachment_wrap">
                                <img src="/static/images/@attachment.png" alt="" />
                            </div> -->
                            <!-- <div class="btn_wrap pt-10">
                                    <div class="btn_right">
                                        <a href="javascript:" class="btn_sm_white" >PC</a>
                                        <a href="javascript:" class="btn_sm_white" >Reset All</a>
                                        <a href="javascript:" class="btn_sm_white" >Delete Selected</a>
                                        <a href="javascript:" class="btn_sm_white" >Delete All</a>
                                    </div>
                                </div> -->
                            <innorix-upload
                                :uploadId="pageName"
                                :id="pageName"
                                :name="pageName"
                                :serviceType="serviceType"
                                :onlyUpload="onlyUpload"
                                :attachList="attach"
                                :imageCloud="true"
                                @files="setFiles"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn_wrap_full topLine">
                <a href="javascript:" class="btn_white" @click="pageMove()">List</a>
                <div class="btn_right">
                    <a href="javascript:" class="btn_blue" @click="save()">Register</a>
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import constants from '@/constants';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import InnorixUpload from '~c/InnorixUpload';

export default {
    name: 'imageCloudDetail',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'innorix-upload': InnorixUpload,
    },
    data() {
        return {
            pageName: 'imageCloudDetail',
            pageTitle: '',
            imageId: '',
            subject: '',
            keyword1: '',
            keyword2: '',
            keyword3: '',
            fileName: '',
            fileSize: '',
            fileFormat: '',
            category1Code: '',
            category2Code: '',
            category3Code: '',
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
            serviceType: 'common',
            attach: [],
            onlyUpload: false,
            attachFileSeq: [],
            delAttachFiles: [],
            isRemove: false,
        };
    },
    mounted() {
        this.categoryList(1);
    },
    methods: {
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1Code = '';
                this.category2Code = '';
                this.category3Code = '';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category1CodeList = resp;
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2Code = '';
                this.category3Code = '';
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category2CodeList = resp;
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3Code = '';
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category3CodeList = resp;
                });
            }
        },
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, addCondition);
            return codeResp;
        },
        pageMove() {
            return this.$router.push({ name: 'imageCloudList' });
        },
        setFiles(val) {
            this.attachFileSeq = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;

            if (this.attachFileSeq.length) {
                let fileName = val.fileList[0].printFileName.split('.');
                this.fileName = fileName[0];
                this.fileFormat = fileName[1].toLowerCase();
                this.fileSize = val.fileList[0].fileSize;
            }
            console.log('fileName', this.attachFileSeq, this.fileName, this.fileFormat, this.fileSize);
        },
        save() {
            let MENDATORY = SDLUtil.getMsgProp('MESSAGE.FIELD.CHECK.MENDATORY');
            let LENGTH = SDLUtil.getMsgProp('MESSAGE.DATA.MAX.LENGTH');

            if (SDLUtil.isNull(this.subject)) {
                SDLUtil.alert(MENDATORY);
                return false;
            } else if (!SDLUtil.lengthCheck(this.subject, 90)) {
                SDLUtil.alert('[' + SDLUtil.getMsgProp('FIELD.GLOBAL.TITLE') + ']' + LENGTH.replace('{0}', '90'));
                return false;
            } else if (SDLUtil.isNull(this.category1Code)) {
                SDLUtil.alert(MENDATORY);
                return false;
            } else if (SDLUtil.isNull(this.keyword1)) {
                SDLUtil.alert(MENDATORY);
                return false;
            } else if (SDLUtil.isNull(this.attachFileSeq)) {
                SDLUtil.alert(MENDATORY);
                return false;
            }

            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.SAVE.CONFIRM'),
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/imageCloud/save.skp`;
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            url,
                            qs.stringify({
                                // imageId: this.imageId,
                                subject: this.subject.trim(),
                                keyword1: this.keyword1.trim(),
                                keyword2: this.keyword2.trim(),
                                keyword3: this.keyword3.trim(),
                                category1Code: this.category1Code,
                                category2Code: this.category2Code,
                                category3Code: this.category3Code,
                                attachFileSeq: this.attachFileSeq.map(item => item.attachFileSeq),
                                delAttachFiles: this.delAttachFiles.map(item => item.attachFileSeq),
                                isRemove: this.isRemove,
                                fileName: this.fileName,
                                fileSize: this.fileSize,
                                fileFormat: this.fileFormat,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            this.imageId = resp.data.imageId;
                            SDLUtil.alert(resp.data.msg);
                            return this.pageMove();
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/tool/imageCloudDetail.vue